export default "__VITE_ASSET__DC3b4Ssc__"